import { render, staticRenderFns } from "./appendix-trans.vue?vue&type=template&id=10036b26&scoped=true"
import script from "./appendix-trans.vue?vue&type=script&lang=js"
export * from "./appendix-trans.vue?vue&type=script&lang=js"
import style0 from "./appendix-trans.vue?vue&type=style&index=0&id=10036b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10036b26",
  null
  
)

export default component.exports